import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../components/shared/layout';
import SEO from '../../components/SEO/SEOPage';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import {
  wrapper,
  featuredWrapper,
  noFeaturedWrapper,
  breakpoints,
  ContentStyles,
  ContentStylesExt, color
} from "../../utils/style"
import Breadcrumbs from '../../components/shared/Breadcrumbs';
import Parallax from '../../components/shared/Parallax';

const WrapperDesktop = styled('div')`
  ${wrapper}
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.sm}) {
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
  }
`;

const FeaturedWrapper = styled('div')`
  ${featuredWrapper}
  position: relative;
  max-height: 600px;
  overflow: hidden;
  margin-bottom: 30px;
  h1 {
    margin-top: 30px;
  }
  .gatsby-image-wrapper {
    border-radius: 24px;
  }
  img {
    border-radius: 24px;
  }
  @media (max-width: ${breakpoints.md}) {
    .gatsby-image-wrapper, img {
      border-radius: 10px;
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    h1 {
      font-size: 1.5rem;
      margin-top: 20px;
      left: 20px;
    }
  }
`;

const NoFeaturedWrapper = styled('div')`
  ${noFeaturedWrapper}
`;

const ContentWrapper = styled('div')`
  ${wrapper}
  ${ContentStyles}
  ${ContentStylesExt}
  padding: 0;
  margin-bottom: 40px;
  iframe {
    min-height: 600px;
  }
  .button-group {
    margin-top: 20px;
    .pink-button {
      margin-right: 24px;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    iframe {
      min-height: 400px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    iframe {
      min-height: 215px;
    }
    .button-group {
      margin-top: 16px;
    }
  }
`;


const PageTemplate = ({ data, pageContext }) => {
  const currentPage = data.wordpressPage;
  const breadcrumbs = pageContext.breadcrumbs;
  const page_title = pageContext.page_title;
  const featuredMedia = currentPage.featured_media;
  const metaTitle = (currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_title)
    ? currentPage.yoast_meta.yoast_wpseo_title : currentPage.title + "- " + process.env.OWNER;
  const metaDesc = (currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_metadesc)
    ? currentPage.yoast_meta.yoast_wpseo_metadesc : '';
  const socialImage = currentPage.featured_media?.localFile?.publicURL;

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentPage.path}
        breadcrumbs={breadcrumbs}
        socialImage={socialImage}
      />
      <Parallax />
      <WrapperDesktop>
        {featuredMedia
        && featuredMedia.localFile
        && featuredMedia.localFile.childImageSharp
        && featuredMedia.localFile.childImageSharp.fluid ?
          <FeaturedWrapper>
            <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title}/>
            <Img fluid={featuredMedia.localFile.childImageSharp.fluid}
                 alt={(currentPage.featured_media.alt_text) ? currentPage.featured_media.alt_text : page_title} fadeIn={false} loading='eager' />
            <h1 dangerouslySetInnerHTML={{ __html: page_title }}/>
            <div className="decorative-line"/>
          </FeaturedWrapper>
          : <NoFeaturedWrapper>
            <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title}/>
            <h1 dangerouslySetInnerHTML={{ __html: page_title }}/>
            <div className="decorative-line"/>
          </NoFeaturedWrapper>
        }

        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: currentPage.content }}/>
        </ContentWrapper>
      </WrapperDesktop>
    </Layout>
  );
};

export default PageTemplate;

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPage(id: { eq: $id }) {
      wordpress_id
      title
      content
      date(formatString: "MMMM DD, YYYY")
      path
      yoast_meta {
        yoast_wpseo_title
        yoast_wpseo_metadesc
      }
      acf {
        page_template
      }
      featured_media {
        alt_text
        localFile {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }  
      } 
    }
  }
`;
